import React, { useState, useEffect } from "react";
import { CourseCard } from "../myCourses/CourseCard";
import BreadTag from "components/dashboard/home/BreadTag";
import { useNavigate } from "react-router-dom";
import { CourseServices } from "services/courses";

const MyTraining = () => {
  const roles = JSON.parse(sessionStorage.getItem("#roles") || "{}");
  const navigate = useNavigate();
  const [teacherCourses, setTeachersCourses] = useState([]);
  console.log(teacherCourses, "teacherCourses");
  const [isLoading, setLoading] = useState(false);
  const [endpoint, setApiEndpoint] = useState("");
  const [bgColor, setBgColor] = useState("");
  const [color, setColor] = useState("");
  const [rateBg, setRateBg] = useState("");
  const [textColor, setTextColor] = useState("");

  useEffect(() => {
    if (roles) {
      if (roles === "student") {
        setBgColor("bg-primary");
        setColor("primary");
        setTextColor("text-primary");
        setRateBg("bg-primary");
        setApiEndpoint("/student-dashboard-endpoint");
      } else if (roles === "teacher") {
        setBgColor("bg-blueColor");
        setColor("blueColor");
        setTextColor("text-blueColor");
        setRateBg("bg-blueColor");
        setApiEndpoint("/teacher-dashboard-endpoint");
      } else {
        setBgColor("bg-greenColor");
        setColor("greenColor");
        setTextColor("text-greenColor");
        setRateBg("bg-greenColor");
        setApiEndpoint("/guest-dashboard-endpoint");
      }
    }
  }, [roles, navigate]);
  const getBorderColorClass = (color) => {
    switch (color) {
      case "primary":
        return "border-b-primary";
      case "blueColor":
        return "border-b-blueColor";
      // Add more cases as needed
      default:
        return "";
    }
  };

  const getTextColorClass = (textColor) => {
    // Define mapping if needed or return directly if textColor is a valid Tailwind class
    return textColor;
  };
  useEffect(() => {
    getTeachersCourses();
  }, []);

  const getTeachersCourses = async (endpoint) => {
    setLoading(true);
    try {
      const response = await CourseServices.fetchTeacher();
      // console.log("fetch event", response);
      if (response.data.status === "success") {
        const res = response.data.data.details;
        setTeachersCourses(res?.rows);
        setLoading(false);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  // const courses = [
  //   {
  //     id: 1,
  //     img: "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
  //     profileImg:
  //       "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
  //     dept: "Science",
  //     text: "Advanced Chemistry- Introduction to Chemistry For SS3 Students",
  //     instructorName: "Adebayo olawuyi",
  //     activityText: "Introduction to Chemistry",
  //     instructorRole: "Instructor",
  //     courseDescription:
  //       "The impact of these pre-colonial political arrangements on federalism in Nigeria is profound. As the country transitioned to colonial rule, British colonial administrators recognized the diversity of indigenous political systems and sought to govern Nigeria through a system of indirect rule. This approach preserved traditional authorities and structures of governance at the local level while establishing a centralized colonial administration.",
  //     status: "ongoing",
  //     rate: 70,
  //   },
  //   {
  //     id: 2,
  //     img: "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
  //     profileImg:
  //       "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
  //     dept: "Arts & Humanities",
  //     text: "Government: The Pre-Colonial Era in Nigeria",
  //     activityText: "Government: The Pre-Colonial Era",
  //     instructorName: "Adebayo olawuyi",
  //     instructorRole: "Instructor",
  //     courseDescription:
  //       "The impact of these pre-colonial political arrangements on federalism in Nigeria is profound. As the country transitioned to colonial rule, British colonial administrators recognized the diversity of indigenous political systems and sought to govern Nigeria through a system of indirect rule. This approach preserved traditional authorities and structures of governance at the local level while establishing a centralized colonial administration.",
  //     status: "ongoing",
  //     courseOutcome: [
  //       {
  //         id: "1",
  //         outcome: "Understanding the diverse indigenous political structures",
  //       },
  //       {
  //         id: "2",
  //         outcome: "Colonial legacies contribute to contemporary challenges.",
  //       },
  //       {
  //         id: "3",
  //         outcome: "The groundwork for Nigeria's federal system.",
  //       },
  //       {
  //         id: "4",
  //         outcome: "Opportunities for unity, equity, and prosperity",
  //       },
  //     ],
  //     audience:"Pretium at parturient curabitur eget nunc pharetra. Vitae pharetra adipiscing purus faucibus bibendum. Ultrices mi tristique et enim pretium lacus, vivamus. Augue eget fermentum, mauris viverra. Tristique arcu ipsum risus a arcu pellentesque pharetra velit.",
  //     rate: 70,
  //   },
  //   {
  //     id: 3,
  //     img: "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
  //     profileImg:
  //       "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
  //     dept: "Sciences",
  //     text: "Introduction to Further Mathematics For SS1 Students",
  //     activityText: "Introduction to Further Mathematics",
  //     instructorName: "Adebayo olawuyi",
  //     instructorRole: "Instructor",
  //     rate: 70,
  //     status: "ongoing",
  //   },
  //   {
  //     id: 4,
  //     img: "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
  //     profileImg:
  //       "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
  //     dept: "Sciences",
  //     text: "Introduction to Further Mathematics For SS1 Students",
  //     activityText: "Introduction to Further Mathematics",
  //     instructorName: "Adebayo olawuyi",
  //     instructorRole: "Instructor",
  //     status: "ongoing",
  //     rate: 50,
  //   },
  //   {
  //     id: 5,
  //     img: "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
  //     profileImg:
  //       "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
  //     dept: "Sciences",
  //     text: "Introduction to Further Mathematics For SS1 Students",
  //     activityText: "Introduction to Further Mathematics",
  //     instructorName: "Adebayo olawuyi",
  //     instructorRole: "Instructor",
  //     status: "ongoing",
  //     rate: 70,
  //   },
  //   {
  //     id: 6,
  //     img: "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
  //     profileImg:
  //       "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
  //     dept: "Sciences",
  //     text: "Introduction to Further Mathematics For SS1 Students",
  //     activityText: "Introduction to Further Mathematics",
  //     instructorName: "Adebayo olawuyi",
  //     instructorRole: "Instructor",
  //     rate: 40,
  //     status: "ongoing",
  //   },
  //   {
  //     id: 7,
  //     img: "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
  //     profileImg:
  //       "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
  //     dept: "Sciences",
  //     text: "Introduction to Further Mathematics For SS1 Students",
  //     activityText: "Introduction to Further Mathematics",
  //     instructorName: "Adebayo olawuyi",
  //     instructorRole: "Instructor",
  //     status: "ongoing",
  //     rate: 70,
  //   },
  //   {
  //     id: 8,
  //     img: "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
  //     profileImg:
  //       "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
  //     dept: "Sciences",
  //     text: "Introduction to Further Mathematics For SS1 Students",
  //     activityText: "Introduction to Further Mathematics",
  //     instructorName: "Adebayo olawuyi",
  //     instructorRole: "Instructor",
  //     rate: 70,
  //     status: "ongoing",
  //   },
  //   {
  //     id: 9,
  //     img: "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
  //     profileImg:
  //       "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
  //     dept: "Sciences",
  //     text: "Introduction to Further Mathematics For SS1 Students",
  //     activityText: "Introduction to Further Mathematics",
  //     instructorName: "Adebayo olawuyi",
  //     instructorRole: "Instructor",
  //     rate: 70,
  //     status: "ongoing",
  //   },
  //   {
  //     id: 10,
  //     img: "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
  //     profileImg:
  //       "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
  //     dept: "Sciences",
  //     text: "Introduction to Further Mathematics For SS1 Students",
  //     activityText: "Introduction to Further Mathematics",
  //     instructorName: "Adebayo olawuyi",
  //     instructorRole: "Instructor",
  //     status: "ongoing",
  //     rate: 70,
  //   },
  //   {
  //     id: 11,
  //     img: "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
  //     profileImg:
  //       "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
  //     dept: "Sciences",
  //     text: "Introduction to Further Mathematics For SS1 Students",
  //     activityText: "Introduction to Further Mathematics",
  //     instructorName: "Adebayo olawuyi",
  //     instructorRole: "Instructor",
  //     rate: 70,
  //     status: "ongoing",
  //   },
  // ];

  const statuses = ["ongoing", "completed", "saved"];
  const [courseStatus, setCourseStatus] = useState("ongoing");

  const handleViewClick = (id) => {
    const selectedCourse = teacherCourses.find((course) => course.id === id);
    navigate("../my-training", {
      state: { courseData: selectedCourse }, // Pass the entire row data as state
    });
    localStorage.setItem("#courseRow", JSON.stringify(selectedCourse.id));
    console.log("View course Detail", selectedCourse.id);
  };

  // const filteredData = teacherCourses.filter((item) => item.status === courseStatus);
  return (
    <div className="p-6 bg-gray-100 flex-1 overflow-auto">
      <BreadTag
        title={"Discover All"}
        item1={"dashboard"}
        item3={"My Training"}
        onClick1={() => navigate("../home")}
        onClick3={() => navigate("../my-courses/discover-all")}
      />
      <div className="flex gap-12 py-4 font-semibold items-center text-sm">
        {statuses.map((status) => (
          <button
            className={`px-6 py-2 text-[16px] font-ManropeSemibold leading-[24px] pb-[4px] capitalize font-medium ${
              status === courseStatus
                ? `transition-all duration-100 border-b-4 ${getBorderColorClass(
                    color
                  )} ${getTextColorClass(textColor)}`
                : "bg-none text-neutral"
            }`}
            key={status}
            onClick={() => setCourseStatus(status)}
          >
            {status}
          </button>
        ))}
      </div>
      <div className="grid gap-6 lg:grid-cols-4 md:grid-cols-3 grid-cols-1  ">
        {teacherCourses.map((course) => (
          <CourseCard
            key={course.id}
            {...course}
            handleViewClick={handleViewClick}
          />
        ))}
      </div>
    </div>
  );
};

export default MyTraining;
